import React, {Fragment} from "react";
import ReactDOM from 'react-dom';

export const ModalToRoot = (props) => {
  const portalElement = document.getElementById('overlay-root');
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <>
          {/*<ModalOverlay>*/}
          {props.children}
          {/*</ModalOverlay>*/}
          {/*<div className="show modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"*/}
          {/*     aria-hidden="true">*/}
          {/*  <div className="modal-dialog">*/}
          {/*    <div className="modal-content">*/}
          {/*      <div className="modal-header">*/}
          {/*        <h5 className="modal-title" id="exampleModalLabel">{props.title}</h5>*/}
          {/*        <button*/}
          {/*          onClick={props.onClickCloseFunction}*/}
          {/*          type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>*/}
          {/*      </div>*/}
          {/*      <div className="modal-body">*/}
          {/*        {props.children}*/}
          {/*      </div>*/}
          {/*      <div className="modal-footer">*/}
          {/*        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>*/}
          {/*        <button type="button" className="btn btn-primary">Save changes</button>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}


        </>,
        portalElement
      )}
    </Fragment>
  );
};